export enum EventType {
  ADD_NEW_SUPPLEMENT_TO_INQUIRY_SUCCESS,
  ADMIN_ACTIVATE_ORGANIZATION_SUCCESS,
  ADMIN_CREATE_NEW_CANNED_RESPONSE_SUCCESS,
  ADMIN_CREATE_NEW_ORGANIZATION_SUCCESS,
  ADMIN_CREATE_NEW_PROGRAM_CODE_SUCCESS,
  ADMIN_CREATE_NEW_SUPPLEMENT_SUCCESS,
  ADMIN_DEACTIVATE_ORGANIZATION_SUCCESS,
  ADMIN_DEACTIVATE_SUPPLEMENT_SUCCESS,
  ADMIN_DELETE_CANNED_RESPONSE_SUCCESS,
  ADMIN_DELETE_GLOBAL_MESSAGE_SUCCESS,
  ADMIN_EDIT_ORGANIZATION_SUCCESS,
  ADMIN_EDIT_PROGRAM_CODE_SUCCESS,
  ADMIN_IMPORT_MEDICATIONS_SUCCESS,
  ADMIN_IMPORT_SUPPLEMENTS_CLEANUP_LIST_SUCCESS,
  ADMIN_IMPORT_INGREDIENTS_CLEANUP_LIST_SUCCESS,
  ADMIN_IMPORT_SYNONYMS_LIST_SUCCESS,
  ADMIN_MARKED_AS_MEDICATION_SUCCESS,
  ADMIN_MARKED_AS_NEEDS_MORE_INFO_SUCCESS,
  ADMIN_MATCH_EXISTING_SUCCESS,
  ADMIN_RENEW_SUPPLEMENT_SUBMITTED,
  ADMIN_SEND_INQUIRY_SUBMITTED,
  ADMIN_SET_GLOBAL_MESSAGE_SUCCESS,
  CREATE_NEW_INQUIRY_SUCCESS,
  CREATE_NEW_SUPPLEMENT_SUCCESS,
  EDIT_NEW_SUPPLEMENT_SUCCESS,
  INQUIRY_SUBMIT_SUCCESS,
  NEEDS_INFO_FORM_SUBMITTED,
  CREATE_NEW_MEDICATION_SUCCESS,
  EDIT_NEW_MEDICATION_SUCCESS,
  ADD_NEW_MEDICATION_TO_INQUIRY_SUCCESS,
  REMOVE_MEDICATION_FROM_INQUIRY_DRAFT_SUCCESS,
  REMOVE_SUPPLEMENT_FROM_INQUIRY_DRAFT_SUCCESS,
  DELETE_INQUIRY_DRAFT_SUCCESS,
  ADMIN_CREATE_NEW_MEDICATION_SUCCESS,
  ADMIN_MEDICATION_MARKED_AS_NEEDS_MORE_INFO_SUCCESS,
  ADMIN_SEND_MEDICATION_INQUIRY_SUBMITTED,
  MEDICATION_NEEDS_INFO_FORM_SUBMITTED,
  ADMIN_IMPORT_HIGH_RISK_SUPPLEMENTS_LIST_SUCCESS,
  ADMIN_CREATE_NEW_INGREDIENT_SUCCESS,
}
